<div class="desc-modal-container">
  <div class="desc-modal-header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="desc-modal-title" mat-dialog-title>{{ title }}</h2>
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
      <button mat-icon-button (click)="copyToClipboard()" [matTooltip]="copied ? copiedText : 'Copy'" class="action-btn">
        <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
      </button>
      <button mat-icon-button (click)="close()" class="action-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div mat-dialog-content class="desc-modal-body">
    <div class="desc-content">{{ text }}</div>
  </div>

  <div mat-dialog-actions align="end" class="desc-modal-actions">
    <button mat-stroked-button color="primary" (click)="close()">
      {{ closeText }}
    </button>
  </div>
</div>
